import React from "react"
import {Application, isBusinessApplicationDocument, isIndividualApplicationDocument} from "../../resources/application"
import {OkDocument} from "../../resources/common"
import ReevaluateBusinessApplicationContainer from "./ReevaluateBusinessApplicationContainer"
import ReevaluateIndividualApplicationContainer from "./ReevaluateIndividualApplicationContainer"
import Admonition from "../../components/Admonitions/Admonition"

interface ReevaluateApplicationContainerProps {
	application: OkDocument<Application>
	enableReevaluateApplication: boolean
}

export default function ReevaluateApplicationContainer({
	application,
	enableReevaluateApplication,
}: ReevaluateApplicationContainerProps) {
	if (isIndividualApplicationDocument(application)) {
		return (
			<ReevaluateIndividualApplicationContainer
				application={application}
				enableReevaluateApplication={enableReevaluateApplication}
			/>
		)
	} else if (isBusinessApplicationDocument(application)) {
		return (
			<ReevaluateBusinessApplicationContainer
				application={application}
				enableReevaluateApplication={enableReevaluateApplication}
			/>
		)
	}

	return <Admonition type="is-danger" title="Invalid application type" message={""} />
}
